import { render } from "./ModalEmpresa.vue?vue&type=template&id=2b4af98d&scoped=true"
import script from "./ModalEmpresa.vue?vue&type=script&lang=js"
export * from "./ModalEmpresa.vue?vue&type=script&lang=js"

import "./ModalEmpresa.vue?vue&type=style&index=0&id=2b4af98d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4af98d"]])

export default __exports__